import React from "react";
import PageHeader from "../components/PageHeader";
import { Button } from "../components/ui/button";
import { Download, FileSpreadsheet } from "lucide-react";
import { API_BASE } from "../lib/api";
import { toast } from "sonner";

const REPORTS = [
  { id: "limit-utilization", label: "Loan Limit Utilization", description: "Utilisasi limit per fasilitas dan borrower" },
  { id: "group-exposure", label: "Group Obligor Exposure", description: "Eksposur konsolidasi per group obligor" },
  { id: "collateral-coverage", label: "Collateral Coverage", description: "Coverage ratio dan shortfall collateral" },
  { id: "covenant-breach", label: "Covenant Breach", description: "Daftar covenant dalam status breach" },
  { id: "facility-maturity", label: "Facility Maturity", description: "Jadwal jatuh tempo fasilitas" },
  { id: "connected-obligor", label: "Connected Obligor", description: "Borrower yang saling terhubung" },
  { id: "early-warning", label: "Early Warning", description: "Daftar lengkap alert EWS" },
];

export default function Reports() {
  const handleDownload = async (reportId) => {
    try {
      const token = localStorage.getItem("access_token");
      const res = await fetch(`${API_BASE}/reports/${reportId}?format=csv`, {
        headers: { Authorization: `Bearer ${token}` },
        credentials: "include",
      });
      if (!res.ok) throw new Error("Gagal");
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${reportId}.csv`;
      a.click();
      window.URL.revokeObjectURL(url);
      toast.success(`Report ${reportId} diunduh`);
    } catch {
      toast.error("Gagal mengunduh report");
    }
  };

  return (
    <div className="p-8 max-w-[1400px] mx-auto" data-testid="reports-page">
      <PageHeader
        title="Laporan"
        subtitle="Export laporan dalam format CSV untuk audit dan reporting regulator"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {REPORTS.map((r) => (
          <div key={r.id} className="border border-border rounded-md bg-card p-5 flex items-start justify-between" data-testid={`report-card-${r.id}`}>
            <div className="flex items-start gap-3">
              <div className="p-2.5 bg-foreground/5 border border-border rounded-md">
                <FileSpreadsheet className="h-5 w-5" />
              </div>
              <div>
                <h3 className="font-bold text-base">{r.label}</h3>
                <p className="text-xs text-muted-foreground mt-1">{r.description}</p>
              </div>
            </div>
            <Button variant="outline" size="sm" onClick={() => handleDownload(r.id)} data-testid={`download-${r.id}`}>
              <Download className="h-3.5 w-3.5 mr-1.5" /> CSV
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
